<template>
  <div class="security-container">
    <div class="security-container_ cen">
      <div class="inside-main">
        <div class="security-main">
          <div class="volunteer-detail-item">个人安全信息</div>
          <div class="security-form">
            <div class="security-inputbox">
              <div class="security-item">邮箱：</div>
              <div class="security-input">
                <div class="security-cont" v-if="email">{{email}}</div>
                <div class="security-btn" v-if="email" @click="updateEmail">修改</div>
                <div class="security-btn" v-else @click="bindEmail">绑定</div>
              </div>
            </div>
            <div class="security-inputbox">
              <div class="security-item">手机号：</div>
              <div class="security-input">
                <div class="security-cont" v-if="mobile">{{mobile}}</div>
                <div class="security-btn" v-if="mobile" @click="updateMobile">修改</div>
                <div class="security-btn" v-else @click="bindMobile">绑定</div>
              </div>
            </div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">我的首页</div>
            <div class="enname">Member Center</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li">
              <router-link to="/member/index" class="left-nav-link">
                <div class="chname">基本信息</div>
                <div class="enname">Basic Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li active">
              <router-link to="/member/security" class="left-nav-link">
                <div class="chname">个人安全信息</div>
                <div class="enname">Personal Safety Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/reserve" class="left-nav-link">
                <div class="chname">预约信息</div>
                <div class="enname">Reservation information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/family" class="left-nav-link">
                <div class="chname">我的家庭</div>
                <div class="enname">My Family</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popsbox emailpops">
      <div class="popsbox_">
        <div class="popsbox_close" @click="hideEmailPops"></div>
        <div class="popsbox_head">绑定邮箱</div>
        <div class="dialog-form">
          <div class="dialog-inputbox">
            <div class="dialog-item">新邮箱：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="emailForm.email" class="input" placeholder="常用邮箱地址">
              </div>
            </div>
          </div>
          <div class="dialog-inputbox" style="height: auto;">
            <div class="dialog-item">滑块验证：</div>
            <div class="dialog-input" style="height: auto;">
              <div class="dialog-input_">
                <div id="embed-captcha"></div>
                <p id="wait" class="show">正在加载验证码......</p>
                <p id="notice" class="hide">请先完成验证</p>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="dialog-inputbox">
            <div class="dialog-item">邮箱验证码：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="emailForm.verification" class="input" placeholder="６位数字">
                <div class="verification-btn" @click="getEmailCodeInfo">发送验证码</div>
              </div>
            </div>
          </div>
          <div class="dialog-btn" @click="updateBindEmailDeal">完成</div>
        </div>
      </div>
    </div>
    <div class="popsbox mobilepops">
      <div class="popsbox_">
        <div class="popsbox_close" @click="hideMobilePops"></div>
        <div class="popsbox_head">绑定手机号</div>
        <div class="dialog-form">
          <div class="dialog-inputbox">
            <div class="dialog-item">新手机号：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <Select v-model="mobileForm.area" class="dialog-input-select">
                  <Option value="中国大陆86">中国大陆86</Option>
                </Select>
                <input type="text" maxlength="11" v-model="mobileForm.mobile" class="input sortinput" placeholder="有效手机号">
              </div>
            </div>
          </div>
          <div class="dialog-inputbox" style="height: auto;">
            <div class="dialog-item">滑块验证：</div>
            <div class="dialog-input" style="height: auto;">
              <div class="dialog-input_">
                <div id="embed-captcha2"></div>
                <p id="wait2" class="show">正在加载验证码......</p>
                <p id="notice2" class="hide">请先完成验证</p>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="dialog-inputbox">
            <div class="dialog-item">短信验证码：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="mobileForm.verification" class="input" placeholder="６位数字">
                <div class="verification-btn" @click="getMobileCodeInfo" v-if="time===0">发送验证码</div>
                <div class="verification-btn" @click="getMobileCodeInfo" v-else>{{time}}s后重新发送</div>
              </div>
            </div>
          </div>
          <div class="dialog-btn" @click="updateBindMobileDeal">完成</div>
        </div>
      </div>
    </div>

    <div class="popsbox checkemailpops">
      <div class="popsbox_">
        <div class="popsbox_close" @click="hideCheckEmailPops"></div>
        <div class="popsbox_head">验证邮箱</div>
        <div class="dialog-form">
          <div class="dialog-inputbox">
            <div class="dialog-item">原邮箱：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="checkEmailForm.email" class="input" placeholder="常用邮箱地址">
              </div>
            </div>
          </div>
          <div class="dialog-inputbox" style="height: auto;">
            <div class="dialog-item">滑块验证：</div>
            <div class="dialog-input" style="height: auto;">
              <div class="dialog-input_">
                <div id="embed-captcha3"></div>
                <p id="wait3" class="show">正在加载验证码......</p>
                <p id="notice3" class="hide">请先完成验证</p>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="dialog-inputbox">
            <div class="dialog-item">邮箱验证码：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="checkEmailForm.verification" class="input" placeholder="６位数字">
                <div class="verification-btn" @click="getCheckEmailCodeInfo">发送验证码</div>
              </div>
            </div>
          </div>
          <div class="dialog-btn" @click="checkEmailDeal">完成</div>
        </div>
      </div>
    </div>
    <div class="popsbox checkmobilepops">
      <div class="popsbox_">
        <div class="popsbox_close" @click="hideCheckMobilePops"></div>
        <div class="popsbox_head">验证手机号</div>
        <div class="dialog-form">
          <div class="dialog-inputbox">
            <div class="dialog-item">原手机号：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <Select v-model="checkMobileForm.area" class="dialog-input-select">
                  <Option value="中国大陆86">中国大陆86</Option>
                </Select>
                <input type="text" maxlength="11" v-model="checkMobileForm.mobile" class="input sortinput" placeholder="有效手机号">
              </div>
            </div>
          </div>
          <div class="dialog-inputbox" style="height: auto;">
            <div class="dialog-item">滑块验证：</div>
            <div class="dialog-input" style="height: auto;">
              <div class="dialog-input_">
                <div id="embed-captcha4"></div>
                <p id="wait4" class="show">正在加载验证码......</p>
                <p id="notice4" class="hide">请先完成验证</p>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="dialog-inputbox">
            <div class="dialog-item">短信验证码：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="checkMobileForm.verification" class="input" placeholder="６位数字">
                <div class="verification-btn" @click="getCheckMobileCodeInfo" v-if="time===0">发送验证码</div>
                <div class="verification-btn" @click="getCheckMobileCodeInfo" v-else>{{time}}s后重新发送</div>
              </div>
            </div>
          </div>
          <div class="dialog-btn" @click="checkMobileDeal">完成</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from '../../config/env'
import { mapGetters } from 'vuex'
import { getHeaderData, getSecurityData, getEmailCodeData, updateBindEmail, getMobileCodeData, updateBindMobile, checkBindMobileData, checkEmail, getCheckEmailCode, checkMobile, getCheckMobileCode } from '../../api/getData.js'
import { validateEmail, validateMobile } from '../../assets/js/validate.js'
export default {
  name: 'security',
  data () {
    return {
      headerInfo: {},
      email: '',
      mobile: '',
      emailForm: {
        email: '',
        verification: ''
      },
      mobileForm: {
        area: '中国大陆86',
        mobile: '',
        verification: ''
      },
      checkEmailForm: {
        email: '',
        verification: ''
      },
      checkMobileForm: {
        area: '中国大陆86',
        mobile: '',
        verification: ''
      },
      captchaObj: {},
      time: 0,
      t: ''
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ])
  },
  created () {
    this.getHeaderInfo()
    this.getSecurityInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'member', activeSendMenu: 'security' }).then(() => {}).catch(() => {})
    },
    async getSecurityInfo () {
      let postData = { id: this.getUserId }
      let result = await getSecurityData(postData)
      this.email = result.info_b.email
      this.mobile = result.info_b.mobile
      this.checkEmailForm.email = result.info_b.email
      this.checkMobileForm.mobile = result.info_b.mobile
    },
    async getEmailCodeInfo () {
      let captchaObj = this.captchaObj
      if (this.checkEmail()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice')[0].className = 'show'
          setTimeout(function () {
            $('#notice')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          let postData = {}
          postData.email = this.emailForm.email
          postData.geetest_challenge = $('.emailpops input[name="geetest_challenge"]').val()
          postData.geetest_validate = $('.emailpops input[name="geetest_validate"]').val()
          postData.geetest_seccode = $('.emailpops input[name="geetest_seccode"]').val()
          let result = await getEmailCodeData(postData)
          if (result.code === '1') {
            this.message('验证码发送成功')
          } else {
            this.message('验证码发送失败')
          }
        }
      }
    },
    async updateBindEmailDeal () {
      let captchaObj = this.captchaObj
      if (this.checkEmail()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice')[0].className = 'show'
          setTimeout(function () {
            $('#notice')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          if (this.emailForm.verification === '') {
            this.message('请输入验证码')
            return false
          }
          let postData = {}
          postData.id = this.getUserId
          postData.vercode = this.emailForm.verification
          postData.email = this.emailForm.email
          let result = await updateBindEmail(postData)
          if (result.code === '1') {
            this.message('绑定成功')
            this.emailForm.verification = ''
            this.hideEmailPops()
            this.getSecurityInfo()
          } else {
            this.message(result.msg)
          }
        }
      }
    },
    async getMobileCodeInfo () {
      let self = this
      if (this.time !== 0) {
        return false
      }
      let captchaObj = this.captchaObj
      if (this.checkMobile()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice2')[0].className = 'show'
          setTimeout(function () {
            $('#notice2')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          let postCheckData = {}
          postCheckData.mobile = this.mobileForm.mobile
          let checkResult = await checkBindMobileData(postCheckData)
          if (checkResult.code !== '1') {
            this.message('该手机号已绑定')
            return false
          }
          let postData = {}
          postData.mobile = this.mobileForm.mobile
          postData.geetest_challenge = $('.mobilepops input[name="geetest_challenge"]').val()
          postData.geetest_validate = $('.mobilepops input[name="geetest_validate"]').val()
          postData.geetest_seccode = $('.mobilepops input[name="geetest_seccode"]').val()
          let result = await getMobileCodeData(postData)
          if (result.code === '1') {
            this.time = 60
            this.t = setInterval(function () {
              self.time = self.time - 1
            }, 1000)
            setTimeout(function () {
              clearInterval(this.t)
            }, 60000)
            this.message('验证码发送成功')
          } else {
            this.message('验证码发送失败')
          }
        }
      }
    },
    async updateBindMobileDeal () {
      let captchaObj = this.captchaObj
      if (this.checkMobile()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice2')[0].className = 'show'
          setTimeout(function () {
            $('#notice2')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          if (this.mobileForm.verification === '') {
            this.message('请输入验证码')
            return false
          }
          let postData = {}
          postData.id = this.getUserId
          postData.vercode = this.mobileForm.verification
          postData.mobile = this.mobileForm.mobile
          let result = await updateBindMobile(postData)
          if (result.code === '1') {
            this.message('绑定成功')
            clearInterval(this.t)
            this.time = 0
            this.mobileForm.verification = ''
            this.hideMobilePops()
            this.getSecurityInfo()
          } else {
            this.message(result.msg)
          }
        }
      }
    },

    async getCheckEmailCodeInfo () {
      let captchaObj = this.captchaObj
      if (this.checkCheckEmail()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice3')[0].className = 'show'
          setTimeout(function () {
            $('#notice3')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          let postData = {}
          postData.email = this.checkEmailForm.email
          postData.geetest_challenge = $('.checkemailpops input[name="geetest_challenge"]').val()
          postData.geetest_validate = $('.checkemailpops input[name="geetest_validate"]').val()
          postData.geetest_seccode = $('.checkemailpops input[name="geetest_seccode"]').val()
          let result = await getCheckEmailCode(postData)
          if (result.code === '1') {
            this.message('验证码发送成功')
          } else {
            this.message(result.msg)
          }
        }
      }
    },
    async checkEmailDeal () {
      let captchaObj = this.captchaObj
      if (this.checkCheckEmail()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice3')[0].className = 'show'
          setTimeout(function () {
            $('#notice3')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          if (this.checkEmailForm.verification === '') {
            this.message('请输入验证码')
            return false
          }
          let postData = {}
          postData.vercode = this.checkEmailForm.verification
          postData.email = this.checkEmailForm.email
          let result = await checkEmail(postData)
          if (result.code === '1') {
            this.checkEmailForm.verification = ''
            this.hideCheckEmailPops()
            this.bindEmail()
          } else {
            this.message(result.msg)
          }
        }
      }
    },
    async getCheckMobileCodeInfo () {
      let self = this
      if (this.time !== 0) {
        return false
      }
      let captchaObj = this.captchaObj
      if (this.checkCheckMobile()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice4')[0].className = 'show'
          setTimeout(function () {
            $('#notice4')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          let postCheckData = {}
          postCheckData.mobile = this.checkMobileForm.mobile
          let checkResult = await checkBindMobileData(postCheckData)
          if (checkResult.code === '1') {
            this.message('该手机号未绑定')
            return false
          }
          let postData = {}
          postData.mobile = this.checkMobileForm.mobile
          postData.geetest_challenge = $('.checkmobilepops input[name="geetest_challenge"]').val()
          postData.geetest_validate = $('.checkmobilepops input[name="geetest_validate"]').val()
          postData.geetest_seccode = $('.checkmobilepops input[name="geetest_seccode"]').val()
          let result = await getCheckMobileCode(postData)
          if (result.code === '1') {
            this.time = 60
            this.t = setInterval(function () {
              self.time = self.time - 1
            }, 1000)
            setTimeout(function () {
              clearInterval(this.t)
            }, 60000)
            this.message('验证码发送成功')
          } else {
            this.message('验证码发送失败')
          }
        }
      }
    },
    async checkMobileDeal () {
      let captchaObj = this.captchaObj
      if (this.checkCheckMobile()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice4')[0].className = 'show'
          setTimeout(function () {
            $('#notice4')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          if (this.checkMobileForm.verification === '') {
            this.message('请输入验证码')
            return false
          }
          let postData = {}
          postData.vercode = this.checkMobileForm.verification
          postData.mobile = this.checkMobileForm.mobile
          let result = await checkMobile(postData)
          if (result.code === '1') {
            clearInterval(this.t)
            this.time = 0
            this.checkMobileForm.verification = ''
            this.hideCheckMobilePops()
            this.bindMobile()
          } else {
            this.message(result.msg)
          }
        }
      }
    },

    checkEmail () {
      if (this.emailForm.email === '') {
        this.message('请输入邮箱')
        return false
      }
      if (!validateEmail(this.emailForm.email)) {
        this.message('邮箱格式不正确')
        return false
      }
      return true
    },
    checkMobile () {
      if (this.mobileForm.mobile === '') {
        this.message('请输入手机号')
        return false
      }
      if (!validateMobile(this.mobileForm.mobile)) {
        this.message('手机号格式不正确')
        return false
      }
      return true
    },
    checkCheckEmail () {
      if (this.checkEmailForm.email === '') {
        this.message('请输入邮箱')
        return false
      }
      if (!validateEmail(this.checkEmailForm.email)) {
        this.message('邮箱格式不正确')
        return false
      }
      return true
    },
    checkCheckMobile () {
      if (this.checkMobileForm.mobile === '') {
        this.message('请输入手机号')
        return false
      }
      if (!validateMobile(this.checkMobileForm.mobile)) {
        this.message('手机号格式不正确')
        return false
      }
      return true
    },

    bindEmail () {
      this.getSlideCode()
      window.$('body').css({
        'overflow': 'hidden'
      })
      window.$('.emailpops').stop().fadeIn(500)
    },
    hideEmailPops () {
      window.$('body').css({
        'overflow': 'auto'
      })
      window.$('.emailpops').stop().fadeOut(500)
    },
    bindMobile () {
      this.getSlideCodeMobile()
      window.$('body').css({
        'overflow': 'hidden'
      })
      window.$('.mobilepops').stop().fadeIn(500)
    },
    hideMobilePops () {
      window.$('body').css({
        'overflow': 'auto'
      })
      window.$('.mobilepops').stop().fadeOut(500)
    },

    updateEmail () {
      this.getCheckSlideCode()
      window.$('body').css({
        'overflow': 'hidden'
      })
      window.$('.checkemailpops').stop().fadeIn(500)
    },
    hideCheckEmailPops () {
      window.$('body').css({
        'overflow': 'auto'
      })
      window.$('.checkemailpops').stop().fadeOut(500)
    },
    updateMobile () {
      this.getCheckSlideCodeMobile()
      window.$('body').css({
        'overflow': 'hidden'
      })
      window.$('.checkmobilepops').stop().fadeIn(500)
    },
    hideCheckMobilePops () {
      window.$('body').css({
        'overflow': 'auto'
      })
      window.$('.checkmobilepops').stop().fadeOut(500)
    },

    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    },
    handlerEmbed (captchaObj) {
      this.captchaObj = captchaObj
      // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
      $('#embed-captcha').html('')
      captchaObj.appendTo('#embed-captcha')
      captchaObj.onReady(function () {
        $('#wait')[0].className = 'hide'
      })
    },
    getSlideCode () {
      let self = this
      $.ajax({
        // 获取id，challenge，success（是否启用failback）
        url: baseUrl + '/Verify/Start?t=' + (new Date()).getTime(), // 加随机数防止缓存
        type: 'get',
        dataType: 'json',
        success: function (data) {
          // 使用initGeetest接口
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它做appendTo之类的事件
          initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            new_captcha: data.new_captcha,
            product: 'embed', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
            offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
          }, self.handlerEmbed)
        }
      })
    },
    handlerEmbedMobile (captchaObj) {
      this.captchaObj = captchaObj
      // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
      $('#embed-captcha2').html('')
      captchaObj.appendTo('#embed-captcha2')
      captchaObj.onReady(function () {
        $('#wait2')[0].className = 'hide'
      })
    },
    getSlideCodeMobile () {
      let self = this
      $.ajax({
        // 获取id，challenge，success（是否启用failback）
        url: baseUrl + '/Verify/Start?t=' + (new Date()).getTime(), // 加随机数防止缓存
        type: 'get',
        dataType: 'json',
        success: function (data) {
          // 使用initGeetest接口
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它做appendTo之类的事件
          initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            new_captcha: data.new_captcha,
            product: 'embed', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
            offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
          }, self.handlerEmbedMobile)
        }
      })
    },

    handlerCheckEmbed (captchaObj) {
      this.captchaObj = captchaObj
      // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
      $('#embed-captcha3').html('')
      captchaObj.appendTo('#embed-captcha3')
      captchaObj.onReady(function () {
        $('#wait3')[0].className = 'hide'
      })
    },
    getCheckSlideCode () {
      let self = this
      $.ajax({
        // 获取id，challenge，success（是否启用failback）
        url: baseUrl + '/Verify/Start?t=' + (new Date()).getTime(), // 加随机数防止缓存
        type: 'get',
        dataType: 'json',
        success: function (data) {
          // 使用initGeetest接口
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它做appendTo之类的事件
          initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            new_captcha: data.new_captcha,
            product: 'embed', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
            offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
          }, self.handlerCheckEmbed)
        }
      })
    },
    handlerCheckEmbedMobile (captchaObj) {
      this.captchaObj = captchaObj
      // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
      $('#embed-captcha4').html('')
      captchaObj.appendTo('#embed-captcha4')
      captchaObj.onReady(function () {
        $('#wait4')[0].className = 'hide'
      })
    },
    getCheckSlideCodeMobile () {
      let self = this
      $.ajax({
        // 获取id，challenge，success（是否启用failback）
        url: baseUrl + '/Verify/Start?t=' + (new Date()).getTime(), // 加随机数防止缓存
        type: 'get',
        dataType: 'json',
        success: function (data) {
          // 使用initGeetest接口
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它做appendTo之类的事件
          initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            new_captcha: data.new_captcha,
            product: 'embed', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
            offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
          }, self.handlerCheckEmbedMobile)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .security-container_{
    padding: 40px 0 60px;
  }
  .security-main{
    width: 77.22%;
    padding: 0 0 78px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .volunteer-detail-item{
      border-left: 4px solid #eb6420;
      margin-top: 60px;
      margin-left: 62px;
      padding-left: 25px;
      font-size: 30px;
      line-height: 30px;
      color: #eb6420;
    }
    .security-form{
      margin-top: 50px;
      padding-bottom: 62px;
      .security-inputbox{
        margin-bottom: 43px;
        overflow: hidden;
        .security-item{
          float: left;
          width: 162px;
          margin-right: 3px;
          font-size: 24px;
          line-height: 40px;
          text-align: right;
          color: #333333;
        }
        .security-input{
          height: 40px;
          overflow: hidden;
          .security-cont{
            float: left;
            height: 40px;
            padding: 0 10px;
            border-radius: 5px;
            font-size: 18px;
            line-height: 40px;
            color: #666666;
          }
          .security-btn{
            float: left;
            margin-left: 20px;
            font-size: 24px;
            line-height: 40px;
            color: #4a7abd;
            cursor: pointer;
          }
        }
      }
    }
  }
  .inside-left-nav{
    padding-bottom: 150px;
  }
  .popsbox{
    display: none;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: rgba(0,0,0,0.7);
    .popsbox_{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 625px;
      padding-bottom: 60px;
      background-color: #ffffff;
      border-radius: 5px;
      .popsbox_close{
        position: absolute;
        top: 20px;
        right: 20px;
        width: 28px;
        height: 28px;
        background-image: url("../../assets/images/icons.png");
        background-repeat: no-repeat;
        background-position: -60px -450px;
        cursor: pointer;
        transition: transform 0.5s ease 0s;
        &:hover{
          transform: rotate(180deg);
          background-image: url("../../assets/images/pic06.png");
          background-repeat: no-repeat;
          background-position: 0 0;
        }
      }
      .popsbox_head{
        padding: 40px 42px;
        font-size: 30px;
        line-height: 30px;
        color: #333333;
        font-weight: bold;
      }
      .dialog-inputbox{
        height: 40px;
        margin-bottom: 20px;
        .dialog-item{
          float: left;
          width: 33.92%;
          font-size: 20px;
          line-height: 40px;
          text-align: right;
          color: #333333;
        }
        .dialog-input{
          position: relative;
          float: left;
          width: 66.08%;
          height: 40px;
          .dialog-input_{
            position: relative;
            width: 79.9%;
            .input{
              width: 100%;
              padding: 0 9px;
              border-radius: 5px;
              background-color: #eeeeee;
              font-size: 16px;
              line-height: 40px;
              color: #666666;
              &.sortinput{
                float: right;
                width: 200px;
              }
            }
            .verification-btn{
              position: absolute;
              right: 0;
              top: 0;
              padding: 0 10px;
              font-size: 16px;
              line-height: 40px;
              color: #4878bd;
              cursor: pointer;
            }
          }
        }
      }
      .dialog-btn{
        width: 140px;
        height: 40px;
        border-radius: 5px;
        background-color: #eb6420;
        margin: 40px auto 0;
        font-size: 18px;
        line-height: 40px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  .dialog-input-select{
    width: 120px;
    .ivu-select-item{
      padding: 8px;
      font-size: 16px !important;
      transition: all 0.5s ease 0s;
      color: #333333;
      &:hover {
        background: #eb6420;
        color: #ffffff;
      }
    }
    .ivu-select-item-focus{
      background: #eb6420;
      color: #ffffff;
    }
  }
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  #notice,#notice2,#notice3,#notice4 {
    color: red;
  }
  @media screen and (max-width: 1580px){
    .security-container_{
      padding: 40px 30px 60px;
    }
  }
  @media screen and (max-width: 1200px){
    .security-container_{
      padding: 25px 10px 5px;
    }
    .security-main{
      width: 100%;
      margin-bottom: 20px;
      padding: 30px 0 39px;
      border-radius: 3px;
      .volunteer-detail-item{
        border-left: 2px solid #eb6420;
        margin-top: 0;
        margin-left: 30px;
        padding-left: 22px;
        font-size: 15px;
        line-height: 15px;
      }
      .security-form{
        margin-top: 25px;
        padding-bottom: 31px;
        padding-left: 30px;
        padding-right: 30px;
        .security-inputbox{
          margin-bottom: 11px;
          .security-item{
            float: none;
            width: 100%;
            margin-right: 0px;
            font-size: 14px;
            line-height: 26px;
            text-align: left;
          }
          .security-input{
            height: 30px;
            position: relative;
            .security-cont{
              height: 30px;
              padding: 0;
              margin-right: 20px;
              border-radius: 3px;
              font-size: 12px;
              line-height: 30px;
            }
            .security-btn{
              margin-left: 0;
              font-size: 12px;
              line-height: 30px;
            }
          }
        }
      }
    }
    .inside-left-nav{
      display: none;
    }
    .popsbox{
      .popsbox_{
        top: 50%;
        left: 17px;
        right: 17px;
        transform: translateY(-50%);
        width: auto;
        padding-bottom: 48px;
        border-radius: 3px;
        .popsbox_close{
          position: absolute;
          top: 10px;
          right: 10px;
          width: 14px;
          height: 14px;
          background-size: 230px auto;
          background-position: -30px -225px;
          &:hover{
            background-image: url("../../assets/images/pic06.png");
            background-repeat: no-repeat;
            background-position: 0 0;
            background-size: 13px auto;
          }
        }
        .popsbox_head{
          padding: 34px 24px 18px;
          font-size: 16px;
          line-height: 16px;
        }
        .dialog-inputbox{
          height: auto;
          margin-bottom: 10px;
          padding: 0 22px;
          .dialog-item{
            float: none;
            width: 100%;
            font-size: 14px;
            line-height: 26px;
            text-align: left;
          }
          .dialog-input{
            float: none;
            width: 100%;
            height: 30px;
            .dialog-input_{
              position: relative;
              width: 100%;
              .input{
                width: 100%;
                padding: 0 12px;
                border-radius: 3px;
                font-size: 12px;
                line-height: 30px;
                &.sortinput{
                  float: right;
                  width: 58.33%;
                }
              }
              .verification-btn{
                position: absolute;
                right: 0;
                top: 0;
                padding: 0 12px;
                font-size: 12px;
                line-height: 30px;
              }
            }
          }
        }
        .dialog-btn{
          width: 100px;
          height: 30px;
          border-radius: 3px;
          margin: 50px auto 0;
          font-size: 14px;
          line-height: 30px;
        }
      }
    }
    .dialog-input-select{
      width: 39.58%;
      .ivu-select-item{
        padding: 4px;
        font-size: 12px !important;
      }
    }
  }
</style>
<style lang="less">
  #app .security-container .ivu-select-selection{
    height: 40px;
    margin-right: 0;
    border: none;
    span{
      height: 40px;
      background-color: #eeeeee;
      border-radius: 5px;
      line-height: 40px;
    }
  }
  #app .security-container .ivu-select-selection-focused, #app .security-container .ivu-select-selection:hover{
    border-color: none;
  }
  #app .security-container .ivu-select-visible .ivu-select-selection{
    box-shadow: none;
  }
  #app .security-container .ivu-select-single .ivu-select-selection .ivu-select-placeholder, #app .security-container .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
    font-size: 16px;
    color: #666666;
  }
  @media screen and (max-width: 1200px){
    #app .security-container .ivu-select-selection{
      height: 30px;
      span{
        height: 30px;
        border-radius: 3px;
        line-height: 30px;
      }
    }
    #app .security-container .ivu-select-single .ivu-select-selection .ivu-select-placeholder, #app .security-container .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
      font-size: 12px;
    }
  }
</style>
